import { defineMessages } from "react-intl";

export default defineMessages({
  cancel: {
    id: "cancel"
  },
  cardView: {
    id: "cardView"
  },
  clear: {
    id: "clear"
  },
  close: {
    id: "close"
  },
  copiedToClipboard: {
    id: "copiedToClipboard"
  },
  copyToClipboard: {
    id: "copyToClipboard"
  },
  delete: {
    id: "cardview.delete"
  },
  deleteQuestion: {
    id: "deleteQuestion"
  },
  delete_icon: {
    id: "delete"
  },
  deleting: {
    id: "deleting"
  },
  display: {
    id: "display"
  },
  downloadTooltip: {
    id: "download.buttonTooltip"
  },
  edit: {
    id: "cardview.edit"
  },
  edit_icon: {
    id: "edit"
  },
  generator: {
    id: "generator"
  },
  generators: {
    id: "generators"
  },
  listView: {
    id: "listView"
  },
  lwactions: {
    id: "listview.actions"
  },
  lwcategories: {
    id: "listview.categories"
  },
  lwdescription: {
    id: "listview.description"
  },
  lwedit: {
    id: "listview.edit"
  },
  lwgenerate: {
    id: "listview.generate"
  },
  lwname: {
    id: "listview.name"
  },
  new: {
    id: "cardview.new"
  },
  noDescription: {
    id: "noDescription"
  },
  openNewGenerator: {
    id: "openNewGenerator"
  },
  pressEscToEmpty: {
    id: "pressEscToEmpty"
  },
  run: {
    id: "run"
  },
  runGenerator: {
    id: "runGenerator"
  },
  search: {
    id: "cardview.search"
  },
  typeToSearch: {
    id: "typeToSearch"
  },
  uploadDropZoneDesc : {
    id: "upload.zoneDescription"
  },
  uploadModalTitle : {
    id: "upload.modalTitle"
  },
  uploadTooltip: {
    id: "upload.buttonTooltip"
  },
  valid: {
    id: "cardview.valid"
  },

});



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/translations.js